module.exports = __webpack_public_path__ + "static/img/rank01.eca4a04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v2/rank01.jpg
// module id = NVuq
// module chunks = 76